// Theme persistence + application. Framework-agnostic so it can run from the
// no-FOUC inline script and from React alike.

export type Theme = 'light' | 'dark';

// v3: key bumped for the 2026-07-09 rebrand — dark (the operations-cockpit
// brand theme) becomes the default, so every user lands on the new identity
// once; re-choosing light persists under the new key.
const STORAGE_KEY = 'manage-theme-v3';

export function getStoredTheme(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
}

export function resolveInitialTheme(): Theme {
  // Dark (the rebrand's cockpit theme) is the default; only an explicit
  // stored choice overrides it.
  return getStoredTheme() ?? 'dark';
}

export function currentTheme(): Theme {
  const attr = document.documentElement.getAttribute('data-theme');
  return attr === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

export function setTheme(theme: Theme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // best-effort persistence
  }
  applyTheme(theme);
}

export function initTheme(): void {
  applyTheme(resolveInitialTheme());
}
